import http from "../http-common";
/* eslint-disable */
class PaketWisataItineraryService {
  itineraryList(page, itemPerPage, keyword, paketWisataId) {
    return http.get(
      "/pib-paket-wisata-itinerary/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&paket_wisata_id=" +
        paketWisataId,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    return http.post("/pib-paket-wisata-itinerary", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  update(data) {
    return http.put(`/pib-paket-wisata-itinerary/${data.id}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  delete(id) {
    return http.delete(`/pib-paket-wisata-itinerary/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
}

export default new PaketWisataItineraryService();
